import { Component, Inject } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { OnInit, DoCheck } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-bitacora-autorizacion',
    templateUrl: './modal-bitacora.component.html',
    styleUrls: ['./modal-bitacora.component.css']
})
export class ModalBitacoraComponent implements OnInit, DoCheck {

    loading = true;
    gestiones: any[] = [];
    errorMsg = '';
    pagedGestiones: any[] = [];
    pageIndex = 0;
    pageSize = 5;

    constructor(
        public dialogRef: MatDialogRef<ModalBitacoraComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.loading = data.loading;
        this.gestiones = data.gestiones;
    }

    ngDoCheck(): void {
        if (this.data?.gestiones && this.data.gestiones.length && this.pagedGestiones.length === 0) {
            this.pageIndex = 0;
            this.updatePage();
        }
    }

    ngOnInit(): void {
        this.updatePage();
    }

    onPageChange(event: PageEvent): void {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.updatePage();
    }

    updatePage(): void {
        if (!this.data?.gestiones) return;

        const start = this.pageIndex * this.pageSize;
        const end = start + this.pageSize;

        this.pagedGestiones = this.data.gestiones.slice(start, end);
    }

    cerrar() {
        this.dialogRef.close();
    }
}
